module.exports = __webpack_public_path__ + "media/suture granuloma.ea0e0a30.wav";